
import { mapState } from 'vuex'
import userCountry from '~/components/login/userCountry.vue' // 国家
export default {
  components: { 'user-country': userCountry },
  props: {
    result: {
      // 交易商数据
      type: Object,
      default: () => {}
    },
    type: {
      // 企业类型-服务商1，交易商2
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      firstLoad: true, // 是否为首次加载该组件
      ruleForm: {
        companyCountryCode: this.$store.state.usergetCountry.code,
        name: '',
        phone: '',
        remark: ''
      },
      // rules: {
      //   name: [
      //     { required: true, message: this.$v('请输入真实姓名'), trigger: 'blur' }
      //   ],
      //   phone: [
      //     { required: true, message: this.$v('请输入手机号'), trigger: 'blur' }
      //   ],
      //   remark: [
      //     { required: true, message: this.$v('请输入申请理由'), trigger: 'blur' }
      //   ]
      // },
      roTade: false,
      countries: this.$store.state.LanguageCode != 'zh-cn' && this.$store.state.LanguageCode != 'zh' && this.$store.state.LanguageCode != 'zh-tw' && this.$store.state.LanguageCode != 'zh-hk' ? require('~/static/json/areaCodeEn.json') : require('~/static/json/areaCodeCN.json') // 中文国家列表
    }
  },
  computed: {
    ...mapState({
      usergetCountry: 'usergetCountry'
    }),
    rules() {
      return this.rulesfn()
    }
  },
  watch: {
    roTade(newV) {
      // 监听国家下拉框
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs.userCountry._scrollInit()
        this.$refs.userCountry.getHeight()
      })
    },
    ruleForm: {
      handler(newValue, oldValue) {
        this.$emit('traderform', newValue)
      },
      deep: true
    },
    usergetCountry: {
      handler(newValue, oldValue) {
        console.log(2222)
        this.rulesfn()
      },
      deep: true
    }
  },
  mounted() {
    document.addEventListener('click', this.coutryClose, { passive: true })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    coutryClose(e) {
      // 点击非组件区域关闭下拉框
      this.roTade = false
    },
    setuserCountry(v) {
      this.roTade = false
      this.ruleForm.companyCountryCode = v.code
      this.rulesfn()
      // this.$nextTick(() => {
      //   this.$refs.ruleForm.validate((valid) => {
      //     if (valid) {
      //       console.log('submit!')
      //     } else {
      //       console.log('error submit!!')
      //       return false
      //     }
      //   })
      // })
    },
    init(res) {
      // 初始化回填数据
      if (!res.pdi) return
      const r = res.applicationContent
      this.ruleForm = {
        name: r.userName,
        phone: r.phone,
        remark: r.remark
      }
      this.countries.forEach((item) => {
        if (item.code == r.phoneAreaCode) {
          this.$store.commit('setuserCountry', item) // 更换点击的国家
        }
      })
    },
    rulesfn() {
      console.log(123)
      const phonevalidate = (rule, value, callback) => {
        if (this.$store.state.usergetCountry.code == '0086') {
          // 如果为国内则走国内手机号验证
          if (!this.ruleForm.phone) {
            // return (this.signin.formatError = this.$v('用户手机号有误'))
            return callback(new Error(this.$v('请输入手机号')))
          }
          const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
          if (!myreg.test(this.ruleForm.phone)) {
            return callback(new Error(this.$v('手机号格式错误')))
          }
        } else {
          // 否则走国外手机号验证
          if (!this.ruleForm.phone) {
            return callback(new Error(this.$v('请输入手机号')))
          }
          const myreg = /^.{5,20}$/
          if (!myreg.test(this.ruleForm.phone)) {
            return callback(new Error(this.$v('手机号格式错误')))
          }
        }
        callback()
      }
      const rulesval = {
        name: [
          {
            required: true,
            message: this.$v('请输入真实姓名'),
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            validator: phonevalidate,
            trigger: ['blur', 'change']
          }
        ],
        remark: [
          {
            required: true,
            message: this.$v('请输入申请理由'),
            trigger: 'blur'
          }
        ]
      }
      return rulesval
    },
    validatefn() {
      console.log(123)
      this.$refs.ruleForm.validate((valid) => {
        console.log('true', valid)
        if (valid) {
          this.$emit('validatefn')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openflag() {
      this.roTade = true
      this.$nextTick(() => {
        this.setscroll()
      })
    },
    setscroll() {
      const ele = document.getElementById('filltraderref').querySelectorAll('.adddialog-info')[0]
      ele.scrollTop = 500
    }
  }
}
